import React from 'react';
import { IconBaseProps } from 'react-icons/lib';

const Icon = (props: IconBaseProps) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M8.71744 18.0052C8.31466 17.5788 8.31429 16.9123 8.71662 16.4854L12.9447 12L8.71662 7.5145C8.31429 7.08769 8.31466 6.42117 8.71744 5.99479C9.15433 5.53231 9.8902 5.53231 10.3271 5.99479L15.3513 11.3133C15.7154 11.6987 15.7154 12.3013 15.3513 12.6867L10.3271 18.0052C9.8902 18.4676 9.15433 18.4676 8.71744 18.0052Z"
			fill={props.color}
		/>
	</svg>
);

export default Icon;
